// extracted by mini-css-extract-plugin
export default {"showcase":"StudentShowcase_showcase__RSXTB","grid":"StudentShowcase_grid__D0S8K","item":"StudentShowcase_item__PjFPz"};